module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/description-pict-6ed5f1d66513e051180d28368df8249e.jpg";